// extracted by mini-css-extract-plugin
export default {"container":"SampleType_container__bFw3V","input":"SampleType_input__lHvWA","alert":"SampleType_alert__yHP38"};